<ng-container *ngIf="viewModel$ | async as vm">
  <div class="factors-grid">
    <div
      *ngIf="vm.report.average_external_temperature"
      class='factor1'>
      <app-cp-reports-factors-external-temperature></app-cp-reports-factors-external-temperature>

    </div>
    
    <div
      *ngIf="vm.report.average_internal_temperature"
      [ngClass]="vm.report.average_external_temperature ? 'factor2' : 'factor1'">
      <app-cp-reports-factors-internal-temperature></app-cp-reports-factors-internal-temperature>
    </div>

    <div class="no-factors">
      <div class="content-no-data">
        <img src="/assets/images/control-page/rectangular_medium-general-missingData.svg">
        <app-text class="is-family-bold text-20 text-grey-80 is-justify-center has-spacing-s" [text]="'common-app.__COMING_SOON' | AsyncLang | async"></app-text>

        <app-text class="text-14 text-grey-80 is-justify-center has-spacing-s text-align-center" [text]="'common-app.__EXPLANATORY_FACTORS_COMING_LATER_TEXT' | AsyncLang | async"></app-text>
      </div>
    
    </div> 
  </div>
</ng-container>

